import { useState, useContext, useEffect } from "react";
import DataTable from "react-data-table-component";
import { getPrices } from "../../services/api";
import { AuthContext } from "../../App";

function Prices() {
  const {
    settingsFormActive,
    setSettingsFormActive,
    setEvent,
    setSettingsForm,
    settingsForm,
  } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const columns = [
    {
      name: "Service Name:",
      selector: (row) => row.service_name,
      sortable: true,
    },
    {
      name: "Vehicle:",
      selector: (row) => row.vehicle_name,
      sortable: true,
    },
    {
      name: "From:",
      selector: (row) => row.location_start,
      sortable: true,
    },
    {
      name: "To:",
      selector: (row) => row.location_end,
      sortable: true,
    },
    {
      name: "Price:",
      selector: (row) => `R ${row.price}`,
      sortable: true,
    },
  ];

  const handleRowClicked = (event) => {
    setSettingsForm("price");
    setEvent(event);
    setSettingsFormActive(true);
  };

  useEffect(() => {
    getPrices().then(async (res) => {
      setData(res);
      console.log(res);
    });
  }, []);

  const handleSearch = (event) => {
    console.log(event.target.value);
    setSearchText(event.target.value);
  };

  const filteredData = data.filter((item) =>
    Object.keys(item).some(
      (key) =>
        item[key] !== null &&
        item[key].toString().toLowerCase().indexOf(searchText.toLowerCase()) >
          -1
    )
  );
  return (
    <div>
      <div>
        <input
          type="text"
          value={searchText}
          onChange={handleSearch}
          placeholder="Search"
          style={{
            marginLeft: 20,
            width: 300,
          }}
        />
      </div>
      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        highlightOnHover={true}
        striped={true}
        pointerOnHover={true}
        onRowClicked={(event) => handleRowClicked(event)}
        direction="auto"
        fixedHeader
        fixedHeaderScrollHeight="530px"
        persistTableHead
        responsive
        dense
      />
    </div>
  );
}

export default Prices;
